import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex text-infoColor" }
const _hoisted_2 = { class: "my-auto ml-3 overflow-hidden" }
const _hoisted_3 = { class: "text-2xl font-bold" }
const _hoisted_4 = { class: "text-sm font-bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "|", -1)
const _hoisted_6 = { class: "text-sm font-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "|", -1)
const _hoisted_8 = { class: "text-sm font-bold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "|", -1)
const _hoisted_10 = { class: "text-sm font-bold" }
const _hoisted_11 = { class: "ml-auto mr-5" }
const _hoisted_12 = { class: "text-xs text-center font-black" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-center font-black" }, "回覆率", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 進行決議 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 回覆狀態 ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "flex justify-center" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("OK")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_tag = _resolveComponent("n-tag")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_progress = _resolveComponent("n-progress")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_HosterResponseModalResolution = _resolveComponent("HosterResponseModalResolution")!
  const _component_HosterResponseModalCurrentStatus = _resolveComponent("HosterResponseModalCurrentStatus")!
  const _component_HosterResponseModalFinish = _resolveComponent("HosterResponseModalFinish")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_modal, {
      show: _ctx.showModal,
      "transform-origin": "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_card, {
          style: {"width":"1000px"},
          title: "",
          bordered: false,
          size: "huge",
          role: "dialog",
          "aria-modal": "true",
          closable: "",
          "content-style": _ctx.contentStyle,
          "header-style": _ctx.headerStyle,
          onClose: _ctx.onClose
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.event?.Title), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.event?.Description), 1),
                _createVNode(_component_n_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_tag, {
                      type: "info",
                      bordered: false,
                      color: { color: _ctx.headerStyle.type , textColor: '#fff' }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.statusData.find((s) => s.Value == _ctx.event?.Status)?.Name ?? ""), 1)
                      ]),
                      _: 1
                    }, 8, ["color"]),
                    _hoisted_5,
                    _createElementVNode("span", _hoisted_6, " 待答覆: " + _toDisplayString(_ctx.event?.HeadCount - _ctx.event?.ResponseCount), 1),
                    _hoisted_7,
                    _createElementVNode("span", _hoisted_8, " 回覆截止日期: " + _toDisplayString(_ctx.datetimeString(_ctx.event?.SubmitDueDateUTCDateTime ?? new Date().toISOString())), 1),
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, " 申請人: " + _toDisplayString(_ctx.event?.ApplierName), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_n_progress, {
                  class: "w-12",
                  type: "circle",
                  "stroke-width": 10,
                  percentage: 
              _ctx.percentage(_ctx.event?.ResponseCount ?? 0, _ctx.event?.HeadCount ?? 1)
            ,
                  color: _ctx.themeVars.warningColor,
                  "rail-color": _ctx.changeColor(_ctx.themeVars.warningColor, { alpha: 0.2 })
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.percentage(_ctx.event?.ResponseCount ?? 0, _ctx.event?.HeadCount ?? 1)) + "%", 1)
                  ]),
                  _: 1
                }, 8, ["percentage", "color", "rail-color"]),
                _hoisted_13
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_n_space, null, {
                default: _withCtx(() => [
                  (
              _ctx.event?.IsResolution == _ctx.ParamIsResolution.NotYet &&
              _ctx.selectedTab == 0 &&
              _ctx.event?.Status != _ctx.ParamEventStatus.Cancel 
            )
                    ? (_openBlock(), _createBlock(_component_n_button, {
                        key: 0,
                        size: "large",
                        type: "success",
                        onClick: _ctx.onReadyToSubmit
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_n_button, {
                    size: "large",
                    color: "#000",
                    onClick: _ctx.onClose
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.event?.IsResolution == _ctx.ParamIsResolution.NotYet && _ctx.event?.Status != _ctx.ParamEventStatus.Cancel)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_n_button_group, { class: "mb-5" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_button, {
                        size: "large",
                        type: "success",
                        ghost: _ctx.tabType(0),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedTab=0))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }, 8, ["ghost"]),
                      _createVNode(_component_n_button, {
                        size: "large",
                        type: "success",
                        ghost: _ctx.tabType(1),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTab=1))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["ghost"])
                    ]),
                    _: 1
                  }),
                  (_ctx.selectedTab==0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.event !== null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_HosterResponseModalResolution, { event: _ctx.event }, null, 8, ["event"]),
                              _hoisted_16
                            ], 64))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, "There is no data."))
                      ], 64))
                    : (_ctx.selectedTab==1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.event !== null)
                            ? (_openBlock(), _createBlock(_component_HosterResponseModalCurrentStatus, {
                                key: 0,
                                event: _ctx.event
                              }, null, 8, ["event"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createBlock(_component_HosterResponseModalFinish, {
                  key: 1,
                  event: _ctx.event
                }, null, 8, ["event"]))
          ]),
          _: 1
        }, 8, ["content-style", "header-style", "onClose"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_n_modal, {
      show: _ctx.showConfirmModal,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showConfirmModal) = $event)),
      "mask-closable": false,
      preset: "dialog",
      title: "小提醒視窗",
      content: _ctx.ConfirmMessage,
      "positive-text": "Yes",
      onPositiveClick: _ctx.onPositiveClick,
      onNegativeClick: _ctx.onNegativeClick,
      "negative-text": "No"
    }, null, 8, ["show", "content", "onPositiveClick", "onNegativeClick"])
  ], 64))
}